import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@core/states/app.state';
import { selectHasRole } from '@core/states/auth/auth.selectors';
import { UserRoleType } from '@corezilla/api';

@Directive({
  selector: '[appHasRole]',
})
export class HasRoleDirective {
  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private store: Store<AppState>
  ) {}

  @Input() set appHasRole(roles: UserRoleType[]) {
    const isAllowed = this.store.selectSignal(selectHasRole(roles || []))();

    if (isAllowed) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
